import './ServicesDropdown.css';
import { Link } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';

const ServicesDropdown = ({ closeDropdown }) => {
  const [openSection, setOpenSection] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const dropdownRef = useRef(null);

  // Detect mobile size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Close on outside click only
 useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      closeDropdown?.(); // ✅ closes dropdown on outside click
    }
  };
  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, [closeDropdown]);

const handleLinkClick = (path) => {
  closeDropdown?.(); // ✅ closes dropdown immediately
  // navigate(path);
};


  const toggleSection = (section) => {
    setOpenSection(prev => (prev === section ? null : section));
  };

  return (
    <div className="services-mega-dropdown p-4">
      {/* Custom Capabilities */}
      <div className="dropdown-column p-2">
        <h4 onClick={() => isMobile && toggleSection("custom")} className='tracking-[1px]'>
          Custom Capabilities
        </h4>
        {(openSection === "custom" || !isMobile) && (
          <ul>
            <li><Link to="/services/small-molecules" onClick={handleLinkClick}>Small Molecules Synthesis</Link></li>
            <li><Link to="/services/large-molecules" onClick={handleLinkClick}>Large Molecule Synthesis</Link></li>
            <li><Link to="/services/drug-process-development" onClick={handleLinkClick}>Drug And Process Development  </Link></li>
            <li><Link to="/services/impurity-profiling" onClick={handleLinkClick}>Impurity Profiling</Link></li>
            <li><Link to="/services/polymorphism-studies" onClick={handleLinkClick}>Polymorphism Studies</Link></li>
            <li><Link to="/services/deuterated-compounds" onClick={handleLinkClick}>Deuterated Compounds</Link></li>
          </ul>
        )}
      </div>

      {/* Analytical Capabilities */}
      <div className="dropdown-column p-2">
        <h4 onClick={() => isMobile && toggleSection("analytical")} className='tracking-[1px]'>
          Analytical Capabilities
        </h4>
        {(openSection === "analytical" || !isMobile) && (
          <ul>
            <li><Link to="/services/method-development" onClick={handleLinkClick}>Method Development</Link></li>
            <li><Link to="/services/method-validation" onClick={handleLinkClick}>Method Validation</Link></li>
            {/* <li><Link to="/services/method-transfer" onClick={handleLinkClick}>Method Transfer</Link></li> */}
            <li><Link to="/services/stability-studies" onClick={handleLinkClick}>Stability Studies</Link></li>
            <li><Link to="/services/structure-elucidation" onClick={handleLinkClick}>Structure Elucidation And Evaluation</Link></li>
          </ul>
        )}
      </div>

      {/* Regulatory Services */}
      <div className="dropdown-column p-2">
        <h4 onClick={() => isMobile && toggleSection("regulatory")} className='tracking-[1px]'>
          {/* Regulatory Services */}
        </h4>
        {(openSection === "regulatory" || !isMobile) && (
          <ul>
            {/* <li><Link to="/services/regulatory-consulting" onClick={handleLinkClick}>Regulatory Consulting</Link></li>
            <li><Link to="/services/dossier-preparation" onClick={handleLinkClick}>Dossier Preparation</Link></li>
            <li><Link to="/services/dmf-anda-submissions" onClick={handleLinkClick}>DMF AND Submissions</Link></li> */}
          </ul>
        )}

        <h4 onClick={() => isMobile && toggleSection("testing")} className='tracking-[1px]'>
          {/* Analytical Testing */}
        </h4>
        {(openSection === "testing" || !isMobile) && (
          <ul>
            {/* <li><Link to="/services/wet-lab-analysis" onClick={handleLinkClick}>Wet Lab Analysis</Link></li>
            <li><Link to="/services/instrumentation-analysis" onClick={handleLinkClick}>Instrumentation Analysis</Link></li>
            <li><Link to="/services/specialized-testing" onClick={handleLinkClick}>Specialized Testing</Link></li> */}
          </ul>
        )}
      </div>

      {/* Trainings and Audits */}
      <div className="dropdown-column p-2">
        <h4 onClick={() => isMobile && toggleSection("trainings")} className='tracking-[1px]'>
          {/* Trainings and Audits */}
        </h4>
        {(openSection === "trainings" || !isMobile) && (
          <ul>
            {/* <li><Link to="/services/audits" onClick={handleLinkClick}>Audits</Link></li>
            <li><Link to="/services/gmp-glp-trainings" onClick={handleLinkClick}>GMP/GLP Trainings</Link></li> */}
          </ul>
        )}

        <h4 onClick={() => isMobile && toggleSection("other")} className='tracking-[1px]'>
          {/* Other */}
        </h4>
        {(openSection === "other" || !isMobile) && (
          <ul>
            {/* <li><Link to="/services/basic-research" onClick={handleLinkClick}>Basic Research</Link></li>
            <li><Link to="/services/fte-projects" onClick={handleLinkClick}>FTEBased Projects</Link></li> */}
          </ul>
        )}
      </div>
      
    </div>
  );
};

export default ServicesDropdown;